/* eslint max-classes-per-file:0 */
export class APIError extends Error {
  constructor(res, ...args) {
    const message = (res.json || {}).msg || res.statusText || 'Unknown Error'

    super(message, ...args)
    this.status = res.status || 500

    this.name = `${(res.statusText || 'APIError').replace(/\W+/g, '')}`

    this.response = res

    if (Error.captureStackTrace) Error.captureStackTrace(this, APIError)
  }
}

export async function toResponseError(res) {
  const JSON_RES = (res.headers.get('content-type') || '').includes(
    'application/json',
  )
  const json = JSON_RES ? await res.json() : null

  return {
    ...['url', 'status', 'statusText', 'ok', 'redirected'].reduce(
      (z, k) => ({ ...z, [k]: res[k] }),
      {},
    ),
    headers: [...res.headers.entries()].reduce(
      (z, [k, v]) => ({ ...z, [k]: v }),
      {},
    ),
    json,
    response: res,
  }
}

export class UploadError extends Error {
  constructor(message, res, ...args) {
    super(message, ...args)
    this.status = res.status || 500
    this.name = UploadError.name

    Error.captureStackTrace(this, UploadError)
  }
}
